import { render, staticRenderFns } from "./ClaimSearch.vue?vue&type=template&id=e3587bd0"
import script from "./ClaimSearch.vue?vue&type=script&lang=js"
export * from "./ClaimSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports